import { render, staticRenderFns } from "./PreorderInfo.vue?vue&type=template&id=b79d4212&scoped=true&"
import script from "./PreorderInfo.vue?vue&type=script&lang=js&"
export * from "./PreorderInfo.vue?vue&type=script&lang=js&"
import style0 from "./PreorderInfo.vue?vue&type=style&index=0&id=b79d4212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79d4212",
  null
  
)

export default component.exports